import './index.scss'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'
$("#nav3").addClass("active");